import React from "react";
import BillsExcel from "../Reports/ReportsBillsExcel";
import ProrrateoBoton from "./ProrrateoBoton";
import CompletitudBoton from "./CompletitudBoton";
import ReportEnegiaPdf from "../Reports/ReportEnergiaPdf";
import ReportEconomicoPdf from "../Reports/ReportEconomico";
import ReportSostentabilidadPdf from "../Reports/ReportSostentabilidadPdf";

const DownloadReportsMenu = ({
  showDownloadButton,
  data,
  filterOptions,
  dashboard,
}) => {
  const formatInvoiceDataForExcel = (invoices) => {
    return invoices?.map((invoice) => ({
      "nombre del sitio": invoice?.locationName,
      utilidad: invoice?.utilityType,
      proveedor: invoice?.supplier,
      nroCuenta: invoice?.AccountNumber,
      factura: invoice?.Bill_ID,
      lecturaActual: invoice?.readingDate,
      lecturaAnterior: invoice?.previousDate,
      emision: invoice?.invoiceDate,
      vencimiento: invoice?.dueDate,
      costo: invoice?.cost,
      consumo: invoice?.consumption,
      lineItemText: invoice?.lineItemText,
      class: invoice?.class,
      m2: invoice?.m2,
      units: invoice?.units,
    }));
  };

  return (
    <ul className="dropdown-menu dropdown-menu-reports" aria-label="Board">
      {showDownloadButton && (
        <li>
          <BillsExcel
            data={formatInvoiceDataForExcel(data)}
            date={filterOptions}
          />
        </li>
      )}
      <li>
        <ProrrateoBoton filter={filterOptions?.companies || []} />
      </li>
      <li>
        <CompletitudBoton />
      </li>
      {dashboard === "energia" ? (
        <li>
          <ReportEnegiaPdf filterOptions={filterOptions} />
        </li>
      ) : 
      dashboard === "finance" ? (
        <li>
          <ReportEconomicoPdf filterOptions={filterOptions} />
        </li>
      ) : 
      dashboard === "sustainability" ? 
      (
        <li>
            <ReportSostentabilidadPdf filterOptions={filterOptions} />
        </li>
      ) : null}
    </ul>
  );
};

export default DownloadReportsMenu;
